import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../contexts/user.context";
import maintenance from "../../assets/icons/underMaintenance.svg";

export const UnderMaintenance = () => {
  const refrechCount = 15;
  const { checkUnderMaintenance, serverMaintenance } = useContext(UserContext);
  const [refreshCounter, setRefreshCounter] = useState(refrechCount);

  useEffect(() => {
    if (serverMaintenance) {
      if (refreshCounter > 0) {
        setTimeout(() => {
          setRefreshCounter(refreshCounter - 1);
        }, 1000);
      } else {
        checkUnderMaintenance();
        setTimeout(() => {
          setRefreshCounter(refrechCount);
        }, 1000);
      }
    }
  }, [refreshCounter]);
  return (
    <main className="bg-white fixed left-0 top-0 w-[100vw] z-[9999999] min-h-[100vh] flex items-center justify-center gap-16">
      <div>
        <h1>Uh oh,</h1>
        <p className="max-w-xl leading-7">
          Our system is temporarily undergoing maintenance
        </p>
        <div className="mt-5">
          we will try to connect in{" "}
          <span className="text-xl">{refreshCounter}</span> seconds, or click{" "}
          <button
            onClick={() => checkUnderMaintenance()}
            className="text-blue-500"
          >
            try now
          </button>
        </div>
      </div>

      <div>
        <img
          src={maintenance}
          alt="Not Found 404"
          width={500}
          height={500}
          className="max-w-[815px]:w-[300px] max-w-[340px]:w-[240px]"
        />
      </div>
    </main>
  );
};
